import { Box, Button, Card, Typography } from "@mui/material";
import { flowHubHeroCardsConfig } from "./config/flowHubHeroCards.config";
import { FLOW_HUB_ICON_CONFIG, FLOW_HUB_CARD_CONFIG, FLOW_HUB_LAYOUT_CONFIG } from "../../../../../../config/flowhub.config";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useFlowHubCards, CreateCompanyContent, FindExpertContent, PageBuilderAccessPromptModal } from "./hooks/useFlowHubCards";
import { colorsConfig } from "../../../../../../../../config/colors.config";
import { BaseModalComponent } from "../../../../../../../../components/common/BaseModalComponent";
import { useFlowHubAuth } from "../../../../../../hooks/useFlowHubAuth";

const clearCreateCompanyDraft = () => {
  localStorage.removeItem("flowHubPendingCompanyDraft");
  localStorage.removeItem("flowHubResumeCompanyDraft");
};

export const FlowHubHeroCards = () => {
  const {
    createCompanyModalContentProps,
    createCompanyModalKey,
    openCreateCompanyModal,
    findExpertModalContentProps,
    findExpertModalKey,
    openFindExpertModal,
    openPageBuilder,
    pageBuilderPromptModalProps,
  } = useFlowHubCards();

  const { isLoggedIn, hasCompanies } = useFlowHubAuth();

  return (
    <>
      <Box
        sx={{
          ...FLOW_HUB_LAYOUT_CONFIG,
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",

          gap: { xs: 1.6, xl: 2.4 },
          py: { xs: 0.5, xl: 1.4 },
        }}
      >
        {flowHubHeroCardsConfig({
          onCreateCompany: openCreateCompanyModal,
          onFindExpert: openFindExpertModal,
          onLaunchEditor: openPageBuilder,
          isLoggedIn,
          hasCompanies,
        }).map((card, index) => (
          <Card
            sx={{
              ...FLOW_HUB_CARD_CONFIG,
              maxWidth: { xs: "100%", md: "320px", xl: "390px" },
              minHeight: { xs: "150px", xl: "190px" },
              padding: { xs: "1rem", xl: "1.3rem" },
            }}
            key={index}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.2,
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <Box sx={FLOW_HUB_ICON_CONFIG.iconPrimary}>{card.icon}</Box>
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: colorsConfig.textPrimary,
                    fontSize: { xs: "1rem", xl: "1.12rem" },
                  }}
                >
                  {card.title}
                </Typography>
              </Box>
              <Box>
                <Typography
                  sx={{
                    color: colorsConfig.textPrimary,
                    fontSize: { xs: "0.8rem", xl: "0.92rem" },
                    fontWeight: 300,
                  }}
                >
                  {card.description}
                </Typography>
              </Box>
              <Box>
                <Button
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    color: colorsConfig.textTertiary,
                    fontSize: { xs: "0.8rem", xl: "0.92rem" },
                    fontWeight: 500,
                    px: 0.5,
                    py: 0.3,
                    minHeight: 28,
                  }}
                  onClick={() => {
                    if (card.action) {
                      card.action();
                    }
                  }}
                >
                  {card.buttonLabel}
                </Button>
              </Box>
            </Box>
          </Card>
        ))}
      </Box>

      {/* Create Company modal — opened programmatically via openModal() in the hook */}

      <BaseModalComponent
        modalKey={createCompanyModalKey}
        modalLabel="Create Company"
        defaultSizes={{ width: 800 }}
        fitContentHeight
        onClose={clearCreateCompanyDraft}
      >
        <CreateCompanyContent {...createCompanyModalContentProps} />
      </BaseModalComponent>

      {/* Find Expert modal — opened programmatically via openModal() in the hook */}
      <BaseModalComponent
        modalKey={findExpertModalKey}
        modalLabel="Find an Expert"
        defaultSizes={{
          width: {
            xs: "92%",
            sm: 680,
            md: 760,
            lg: 780,
          },
          height: {
            xs: "92%",
            sm: 360,
            md: 420,
            lg: 460,
          },
        }}
      >
        <FindExpertContent {...findExpertModalContentProps} />
      </BaseModalComponent>

      <PageBuilderAccessPromptModal {...pageBuilderPromptModalProps} />
    </>
  );
};
